<nav>
  <div class="logo">
    <a [routerLink]="['/home']" (click)="isMenuOpen = false"><img src="/assets/Logo.svg" /></a>
  </div>

  <button class="hamburger" (click)="toggleMenu()">
    <span class="material-icons">menu</span>
  </button>

  <div class="nav-links" [class.show]="isMenuOpen">
    <div>
      <a (click)="openExternalLink('https://www.facebook.com/CommunitySuperMarket1927/')">
        <img src="/assets/FacebookLogo.png" />
      </a>
      <a (click)="openExternalLink('https://www.instagram.com/communitysupermarket1927/')">
        <img src="/assets/InstagramLogo.png" />
      </a>
    </div>

    <a [routerLink]="['/weeklyspecials']" routerLinkActive="active-link">Weekly Specials</a><span class="pipe">|</span>
    <a [routerLink]="['/services']" routerLinkActive="active-link">Services</a><span class="pipe">|</span>
    <a [routerLink]="['/catering']" routerLinkActive="active-link">Catering</a><span class="pipe">|</span>
    <a [routerLink]="['/shopping']" routerLinkActive="active-link">Online Shopping</a><span class="pipe">|</span>
    <!--<div [routerLink]="['aboutus']">About us</div>-->
    <!--<div [routerLink]="['specialfeatures']">Special Features</div>-->
    <a [routerLink]="['/contactus']" routerLinkActive="active-link">Contact</a>
  </div>

</nav>
